module.exports = __webpack_public_path__ + "img/u102.bb84c401.svg";